/**
 * In build time, environment vars prefix with NEXT_PUBLIC_ will be embedded
 * into the build artifact. This makes build environment specific,
 * and it can't be deployed to other Envs., unless same Configuration can be use.
 *
 * Note: by default in Next.js, NODE_ENV variable is used to define an environment, and variables
 * are loaded from corresponding .env.<NODE_ENV> file.
 * - Since NODE_ENV is a reserved keyword, it should always be set to "production" in any production-like env.;
 * - It's limited to 'production', 'development' and 'testing' envs, we need more environments;
 * Due to the above, instead of using default approach, we rely on ENV variable for configuration and
 * load variables from env.json manually in next.config.js on build time.
 *
 * Usage of env.json file, which is committed to repo, is not the best practice and should be reconsidered in future
 *
 * Refer to this Next.js documentation for more details
 * https://nextjs.org/docs/13/app/building-your-application/configuring/environment-variables
 * section: Bundling Environment Variables for the Browser
 */
export const API_HOST_PROXY = process.env.NEXT_PUBLIC_API_BASE_URL;
export const API_HOST_AUTH = `${process.env.NEXT_PUBLIC_API_BASE_URL}/me`;
export const API_HOST_ADYEN = `${process.env.NEXT_PUBLIC_API_BASE_URL}/adyen-merchant`;
export const API_CART_INVENTORY = `${process.env.NEXT_PUBLIC_API_BASE_URL}/cart-inventory`;
export const API_SEARCH_BFF = `${process.env.NEXT_PUBLIC_API_BASE_URL}/search`;
export const API_PLACEMENT = `${process.env.NEXT_PUBLIC_API_BASE_URL}/placement`;

/**
 * DEFINING SUPPORTED PBC OPTIONS
 */
export enum SEARCH_ENGINE_OPTIONS {
  ALGOLIA = 'algolia',
  COMMERCETOOLS = 'commercetools',
  GRS = 'grs',
  MXP = 'mxp',
  VAIS = 'vais'
}

export enum DAM_OPTIONS {
  CLOUDINARY = 'cloudinary'
}

export enum CMS_OPTIONS {
  CONTENTSTACK = 'contentstack'
}

/**
 * PBC CONFIGURATION VALIDATION
 * IF provided configuration for PBCs is not expected, throws an error
 */
[ [ process.env.NEXT_PUBLIC_SEARCH_ENGINE, SEARCH_ENGINE_OPTIONS ],
  [ process.env.NEXT_PUBLIC_DAM, DAM_OPTIONS ],
  [ process.env.NEXT_PUBLIC_CMS, CMS_OPTIONS ] ].forEach(([ config, options ]) => {
  if (!Object.values(options).includes(config as string)) {
    throw new Error(`
      Invalid environment configuration for PBC: Expected one of: ${Object.values(options)}. Received: ${config}. 
      Re-build is required to apply new configuration.
    `);
  }
});

/**
 * LOADING PBCs CONFIGURATION from env. variables
 */
export const SEARCH_ENGINE = process.env.NEXT_PUBLIC_SEARCH_ENGINE as SEARCH_ENGINE_OPTIONS;
export const DAM = process.env.NEXT_PUBLIC_DAM as DAM_OPTIONS;
export const CMS = process.env.NEXT_PUBLIC_CMS as CMS_OPTIONS;
